export default __webpack_public_path__ + "static/media/image3pro1.c17aa490.jpeg";